import { combineReducers } from 'redux';
import uiTheme from '@reducers/ui-theme';
import dropoffReducer from '@reducers/dropoff-reducer';

export default combineReducers({
  uiTheme,
  dropoffReducer,
});
